// ------------------------------------------------------------------------------
// name: index
// author: mudas
// created: 2025/8/15
// ------------------------------------------------------------------------------

import { UploadFileObjType } from 'common/types';
import service from 'common/service';

export enum OcrType {
  Image = 'IMG',
  Text = 'TEXT',
  Video = 'VIDEO',
}

/**
 * 检查指定文件资源的 OCR 合法性
 * @param file
 * @param type
 */
export const checkOcr = async (file: UploadFileObjType, type: OcrType = OcrType.Image) => {
  return await service.ocr.checkUserInformation({ infoType: type, imgUrl: [file] });
};
